(function () {
  const ja = new Vue({
    el: '#job-assistant-form',
    components: {
      'dmtk-input': DtmkInput,
      'maybe-radio': DmtkRadioMaybe,
      'term-search': TermSearch,
    },
    mixins: [vuelidate.validationMixin],
    data: {
      step: 0,
      tabs: [],
      total: 0,
      modal: null,
      canClose: false,
      loading: false,
      job: {
        tipo: '',
        que: '',
        donde: null,
        formacion: '',
        formacion_extra: '',
        experiencia: '',
        experiencia_extra: '',
        vehiculo: '',
        vehiculo_extra: '',
        carnet: '',
        carnet_extra: '',
        sueldo: '',
        sueldo_extra: '',
        incorporacion: '',
        incorporacion_extra: '',
        modalidad: '',
        oficina: '',
        extra: '',
      },
      user: {
        email: '',
        username: '',
        tos: false,
      },
      modes: {
        'Tiempo completo': 'FULL_TIME',
        'Tiempo parcial': 'PART_TIME',
        Temporal: 'TEMPORARY',
        'Por día/hora': 'PER_DIEM',
        'Por obra': 'CONTRACTOR',
        Otra: 'OTHER',
      },
      office: ['Presencial', 'Híbrido', 'Remoto'],
      result: {
        title: '',
        description: '',
      },
    },
    computed: {
      completed() {
        return Math.round((100 * this.step) / (this.total - 2));
      },
      showNext() {
        return domestiko.user
          ? this.step < this.total - 4
          : this.step < this.total - 3;
      },
      isCompleted() {
        return domestiko.user
          ? this.step === this.total - 4
          : this.step === this.total - 3;
      },
      isUser() {
        return domestiko.user;
      },
    },
    validations() {
      return {
        job: {
          tipo: { required: validators.required },
          que: { required: validators.required },
          donde: { required: validators.required },
          formacion: { required: validators.required },
          experiencia: { required: validators.required },
          vehiculo: { required: validators.required },
          carnet: { required: validators.required },
          sueldo: { required: validators.required },
          incorporacion: { required: validators.required },
          modalidad: { required: validators.required },
        },
        user: {
          username: { required: validators.required },
          email: {
            email: validators.email,
            required: validators.required,
          },
          tos: { checked: (value) => !!value },
        },
        result: {
          title: { required: validators.required },
          description: { required: validators.required },
        },
        steps: {
          0: ['job.tipo'],
          1: ['job.que', 'job.donde'],
          2: ['job.formacion'],
          3: ['job.experiencia'],
          4: ['job.vehiculo', 'job.carnet'],
          5: ['job.modalidad'],
          6: ['job.sueldo', 'job.incorporacion'],
          7: [],
          8: ['user.email', 'user.username', 'user.tos'],
        },
      };
    },
    mounted: function () {
      //Modal y eventos
      const mid = '#job-assistant-modal';
      this.modal = UIkit.modal(mid);
      UIkit.util.on(mid, 'beforehide', (e) => {
        if (this.canClose) return;
        e.preventDefault();
        customConfirm(
          '¿Seguro que quieres salir?',
          'Si cierras el formulario sin publicar tu oferta perderás todos los datos',
        ).then(
          (res) => this.close(),
          () => {},
        );
      });

      //Abrimos para mi usuario
      // domestiko.$on('user.loggedin', (user) => {
      //   if (user.email === 'domestiko@36001.net') {
      //     this.open();
      //   }
      // });

      //Evento genérico
      window.addEventListener('job.assistant', (e) => {
        this.open();
      });
      this.tabs = this.$refs.steps.children;
      this.total = this.tabs.length;
    },
    methods: {
      init(type) {
        if (type === 'E') {
          this.job.tipo = 'E';
        } else {
          this.job.tipo = 'P';
          this.job.modalidad = 'Por obra';
          this.job.sueldo = 'No incluir';
        }
        this.next();
      },
      open() {
        if (this.modal) this.modal.show();
      },
      close() {
        this.canClose = true;
        this.modal.hide();
      },
      prev() {
        return this.select(this.step - 1);
      },
      next() {
        const idx = parseInt(this.step);
        const validation = this.$v.steps[idx] || undefined;
        //console.log(this.job, validation);
        if (validation) {
          validation.$touch();
          if (validation.$invalid) {
            return false;
          }
        }
        return this.select(this.step + 1);
      },
      select(i) {
        //está fuera de límites
        if (i < 0 || i >= this.total) return;

        //si ya está logueado, saltamos
        if (domestiko.user && this.tabs[i].classList.contains('login')) {
          i = i > this.step ? ++i : --i;
        }

        //si es un presupuesto, no hay modalidad
        if (
          this.job.tipo === 'P' &&
          this.tabs[i].classList.contains('modalidad')
        ) {
          i = i > this.step ? ++i : --i;
        }

        //intercambiamos los pasos
        this.step = i;
        [...this.tabs].forEach((tab, index) => {
          index === i
            ? tab.classList.add('-active')
            : tab.classList.remove('-active');
        });

        //enviamos evento ga
        dataLayer.push({
          event: 'jobs_assistant',
          eventCategory: 'step_' + (i + 1),
        });
        console.log('event', 'jobs_assistant', 'step_' + i);

        return true;
      },
      generate() {
        if (!this.next()) {
          return;
        }
        this.loading = true;
        axios
          .post('/empleo/asistente/', {
            job: { ...this.job, donde: this.job.donde.title },
            user: this.user,
          })
          .then((res) => {
            console.log(res.data);
            this.result = res.data.job;
            dataLayer.push({
              event: 'jobs_assistant',
              eventCategory: 'generate',
            });
          })
          .catch((err) => {
            console.log(err);
            customAlert(
              'Error',
              'No se pudo generar el anuncio, por favor vuelva a intentarlo.',
            );
            dataLayer.push({
              event: 'jobs_assistant',
              eventCategory: 'error_generating',
            });
            this.prev();
          })
          .finally(() => {
            this.loading = false;
          });
      },
      publish() {
        this.next();
        this.loading = true;
        if (domestiko.user) {
          this.user = domestiko.user;
        }
        axios
          .put('/empleo/asistente/', {
            user: this.user,
            job: {
              ...this.result,
              type: this.job.tipo,
              location: this.job.donde._id,
              employment: this.modes[this.job.modalidad],
            },
            data: { ...this.job, donde: this.job.donde.title },
          })
          .then((res) => {
            dataLayer.push({
              event: 'jobs_assistant',
              eventCategory: 'publish',
            });
          })
          .catch((err) => {
            console.log(err);
            this.prev();
            customAlert(
              'Error',
              'No se pudo publicar el anuncio, por favor vuelva a intentarlo.',
            );
          })
          .finally(() => {
            this.loading = false;
          });
      },
      goHome() {
        domestiko.user
          ? (document.location.href = '/usuarios/panel/#/empleo')
          : window.location.reload();
      },
    },
    template: `
      <div id="job-assistant-form">
        <div class="progress" v-if="completed < 100">
          {{ completed }}% completado
          <progress class="uk-progress" :value="completed" value="0" max="100"></progress>
        </div>
        <div class="steps" ref="steps">
          <div class="step -active">
            <h2>Encuentra y contrata rápidamente</h2>
            <p>Responde algunas preguntas y encuentra la persona que necesitas. Es gratis y sin compromiso.</p>
            <h3 class="dmtk-blue uk-margin-remove">¡Sólo te llevará un momento!</h3>
            <h3>¿Qué quieres hacer?</h3>
            <div class="uk-form-controls" uk-margin>
              <button class="uk-button -twolines" @click="init('E')">Publicar una oferta de empleo</button>
              <button class="uk-button" @click="init('P')">Solicitar un presupuesto</button>
            </div>
          </div>
          <div class="step">
            <h3>¿Qué necesitas?</h3>
            <dmtk-input
              v-model="job.que"
              :error="$v.job.que.$error"
              label="Explícanos lo que estás buscando"
              placeholder="Ej. Un cocinero con experiencia, cambiar un plato de ducha, ..."
            />
            <h3>¿Dónde lo necesitas?</h3>
            <div class="uk-margin-top">
              <label>Dónde necesitas este servicio</label>
              <term-search
                placeholder="Indica aquí la ciudad o la zona donde se necesita el servicio"
                class="term-search-location"
                v-model="job.donde"
                scope="city"
                taxonomy="regional"
              ></term-search>
              <div class="uk-text-danger" v-if="$v.job.donde.$error">
                Por favor rellena este campo
              </div>
            </div>
          </div>
          <div class="step">
            <h3>Formación y estudios</h3>
            <maybe-radio
              :value="job.formacion"
              :extra="job.formacion_extra"
              @value="job.formacion = $event"
              @extra="job.formacion_extra = $event"
              placeholder="Indica aquí que formación o estudios deber tener el candidato para acceder al puesto de trabajo"
              :error="$v.job.formacion.$error"
              :options="['Requeridos', 'Deseables', 'No necesarios']"
            />
          </div>
          <div class="step">
            <h3>Experiencia</h3>
            <maybe-radio
              :value="job.experiencia"
              :extra="job.experiencia_extra"
              @value="job.experiencia = $event"
              @extra="job.experiencia_extra = $event"
              :options="['Requerida', 'Deseable', 'No necesaria']"
              placeholder="Indica aquí la experiencia mínima que deber tener el candidato para acceder al puesto de trabajo"
              :error="$v.job.experiencia.$error"
            />
          </div>
          <div class="step">
            <h3>Vehículo propio</h3>
            <maybe-radio
              :value="job.vehiculo"
              :extra="job.vehiculo_extra"
              @value="job.vehiculo = $event"
              @extra="job.vehiculo_extra = $event"
              :options="['No necesario', 'Deseable', 'Requerido' ]"
              extraActive="Ninguna"
              :error="$v.job.vehiculo.$error"
            />
            <h3>Carnet de conducir</h3>
            <maybe-radio
              :value="job.carnet"
              :extra="job.carnet_extra"
              @value="job.carnet = $event"
              @extra="job.carnet_extra = $event"
              :error="$v.job.carnet.$error"
              label="Indica otras modalidades de carnet o permisos necesarios"
              :options="['No necesario', 'A: Motos y ciclomotores', 'B: Coches y vehículos ligeros', 'C: Camiones', 'D: Autobuses', 'Especificar']"
              extraActive="Especificar"
            />
          </div>
          <div class="step modalidad">
            <h3>Modalidad</h3>
            <maybe-radio
              label="Especifica la modalidad o los horarios en los que se realizará el trabajo"
              placeholder="Ej. Fines de semana; Dos horas lunes, miércoles y viernes; Noches; ..."
              :value="job.modalidad"
              :extra="job.modalidad_extra"
              @value="job.modalidad = $event"
              @extra="job.modalidad_extra = $event"
              :error="$v.job.modalidad.$error"
              :options="Object.keys(modes)"
              extraActive="Otra"
            />
          </div>
          <div class="step">
            <div v-if="job.tipo !== 'P'">
              <h3>Sueldo</h3>
              <maybe-radio
                :value="job.sueldo"
                :extra="job.sueldo_extra"
                @value="job.sueldo = $event"
                @extra="job.sueldo_extra = $event"
                :error="$v.job.sueldo.$error"
                :options="['Convenio', 'No incluir', 'Especificar']"
                label="Especifica las condiciones económicas de tu oferta"
                placeholder="precio/hora, sueldo mensual, remuneración anual, número de pagas, ..."
                extraActive="Especificar"
              />
            </div>
            <h3>
              {{ job.tipo === 'P' ? 'Inicio de ejecución' : 'Incorporación' }}
            </h3>
            <maybe-radio
              :value="job.incorporacion"
              :extra="job.incorporacion_extra"
              @value="job.incorporacion = $event"
              @extra="job.incorporacion_extra = $event"
              :error="$v.job.incorporacion.$error"
              :options="['Inmediata', 'Otra']"
              label="Indica cuando necesitas que se incorporen al puesto de trabajo"
              extraActive="Otra"
            />
          </div>
          <div class="step">
            <h3>Otra información importante</h3>
            <div class="uk-margin-top">
              <label>Incluye aquí información que sea relevante para el puesto de trabajo</label>
              <textarea class="uk-textarea" rows="4" v-model="job.extra"></textarea>
            </div>
          </div>
          <div class="step login">
            <h3>Datos de contacto</h3>
            <dmtk-input
              v-model="user.username"
              :error="$v.user.username.$error"
              label="Nombre"
            />
            <dmtk-input
              v-model="user.email"
              :error="$v.user.email.$error"
              label="Correo electrónico"
            />
            <div class="tos">
              <hr class="uk-margin-medium-top">
              <p class="legal -tos">
                Responsable del Tratamiento: Luis G. Valdivieso; finalidad del tratamiento: prestación del servicio;
                legitimación del tratamiento: consentimiento del interesado; destinatarios: otros usuarios del sitio
                web,
                colaboradores en la prestación del servicio y autoridades cuando se nos requiera legalmente; derechos:
                acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información
                adicional.
                Derechos: correo a <a href="mailto:privacidad@domestiko.com">privacidad@domestiko.com</a>.
                Más información en la <a href="/info/politica-de-privacidad/" target="_blank">política de privacidad</a>
                y <a
                href="/info/politica-de-cookies/" target="_blank">cookies</a>.
              </p>
              <div class="uk-form-row">
                <input type="checkbox" class="uk-checkbox" v-model="user.tos" />
                He leído las <a href="/info/nota-legal/" target="_blank">condiciones de servicio</a>
                y la <a href="/info/politica-de-privacidad/" target="_blank">política de privacidad de Doméstiko</a>
                y acepto el tratamiento de mis datos para recibir los resultados de mi anuncio.
              </div>
              <span v-if="$v.user.tos.$anyError" class="uk-text-danger">
                Debes aceptar las condiciones de servicio y la política de privacidad
              </span>
            </div>
          </div>
          <div class="step">
            <h3>Revisar</h3>
            <div v-if="loading" class="uk-text-center">
              <img src="/assets/img/gifs/dots.svg" alt="Cargando...">
              <p>
                <small>generando anuncio...</small>
              </p>
            </div>
            <div v-else-if="result.title">
              <p class="uk-margin-medium-bottom">
                Por favor revisa tu anuncio, puedes hacer todos los cambios que desees antes de publicarlo.
              </p>
              <dmtk-input
                v-model="result.title"
                :error="$v.result.title.$error"
                label="Título del anuncio"
              />
              <div class="uk-margin-top">
                <label>Texto del anuncio</label>
                <textarea class="uk-textarea" rows="8" v-model="result.description"></textarea>
              </div>
            </div>
          </div>
          <div class="step">
            <div v-if="loading" class="uk-text-center">
              <img src="/assets/img/gifs/dots.svg" alt="Cargando...">
              <p>
                <small>publicando anuncio...</small>
              </p>
            </div>
            <div v-else-if="result.title" class="uk-text-center">
              <span class="uk-h3">¡Tu oferta se ha añadido con éxito!</span>
              <div class="uk-text-center">
                <img src="/assets/img/drawn/publica.svg" alt="Ofertas de empleo" class="uk-img" />
              </div>
              <p v-if="isUser">
                Hemos recibido tu oferta y nuestros administradores la validarán lo antes posible.
                Recibirás un correo cuando esté disponible para el público.
                <br><br>
                Gracias por confiar en Doméstiko.
              </p>
              <p v-else>
                Para que esté disponible al público primero tienes que validar tu cuenta.
                Te hemos enviado un mensaje por correo electrónico, sigue las instrucciones.
                <br><br>
                Gracias por confiar en Doméstiko.
              </p>
            </div>
          </div>
        </div>
        <div class="buttons uk-text-right" v-if="step > 0">
          <hr class="uk-margin-large-top">
          <button class="uk-button"
                  v-if="step < total-1" :disabled="step === 0" @click="prev()">Anterior
          </button>
          <button class="uk-button uk-button-primary"
                  v-if="showNext" :disabled="loading" @click="next()">Siguiente
          </button>
          <button class="uk-button uk-button-primary"
                  v-if="isCompleted" :disabled="loading" @click="generate()">Generar anuncio
          </button>
          <button class="uk-button uk-button-primary"
                  v-if="step === total-2" :disabled="loading" @click="publish()"
          >Publicar oferta
          </button>
          <button v-if="step === total-1" class="uk-button uk-button-primary" @click="goHome()">
            {{ isUser ? 'Ver mis ofertas' : 'Seguir navegando' }}
          </button>
        </div>
      </div>
    `,
  });
})();
